<nav class="flow-indicator" aria-label="Current procedure">
  <p class="flow-indicator__text">
    <span class="flow-indicator__label">Estás en:</span>
    <span class="flow-indicator__current">Solicitud de Pensión por Invalidez</span>
  </p>
</nav>
